import React, { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Button } from "react-bootstrap";
import { Button as PrimeButton } from "primereact/button";
import { Dropdown } from "primereact/dropdown";
import { Checkbox } from "primereact/checkbox";
import { FilterMatchMode } from "primereact/api";
import { InputText } from "primereact/inputtext";
import { Calendar } from "primereact/calendar";
import { Toast } from "primereact/toast";
import { Dialog } from "primereact/dialog";
import { ProgressSpinner } from "primereact/progressspinner";
import { ConfirmDialog } from "primereact/confirmdialog";
import { Message } from "primereact/message";
import { InputTextarea } from "primereact/inputtextarea";
import { Editor } from "primereact/editor";
import axios from "axios";

import {
    SERVICE_LOCATION, GET_WORKSHEETS_BETWEEN_DATES, DOWNLOAD_SUBMITTED_WORKSHEETS, UPDATE_SUBMISSION_STATUS, GET_FITTERS_API,
    GET_SUBMISSION_STATUS, GET_SITE_CONTACTS_BY_SYSTEMID, ADD_SITE_CONTACTS, PROCESS_WAGES,
    GET_WAGES_FOR_MEASURE, CHECK_IF_WAGES_PROCESSED, UPLOAD_CUSTOMER_PAYMENT_FORM
} from "./../constants/endpoints";
import { WORKCARDS_DOWNLOADED, COMPLETE_ALL_FIELDS, WORK_SHARE_100_PERCENT } from "./../constants/errors";
import { TITLES, SUBMISSION_STATUS } from "../constants/newBuildConstants";

import "./../assets/styles/table.css";
import "./../assets/styles/worksheets.css";

const Worksheets = (props) => {
    const toast = useRef(null);
    const fileInputRef = useRef(null);

    const navigate = useNavigate();

    const titles = TITLES;

    const { data } = props;
    const userDepot = (data !== undefined && data !== null) ? data.data.userDetails.depot : "";
    const userName = (data !== undefined && data !== null) ? data.data.userDetails.userName : "";

    const [worksheets, setWorksheets] = useState(null);
    const [selectedWorksheets, setselectedWorksheets] = useState(null);
    const [pendingWorksheets, setPendingWorksheets] = useState(null);
    const [toBeStatusChangedWorksheet, setToBeStatusChangedWorksheet] = useState(null);
    const [currentPendingWorksheet, setCurrentPendingWorksheet] = useState(null);
    const [disableDownloadButton, setDisableDownloadButton] = useState(true);

    const [disableChangeStatusButton, setDisableChangeStatusButton] = useState(true);
    const [disableUploadPaymentFormButton, setDisableUploadPaymentFormButton] = useState(true);
    const [submissionStatusList, setSubmissionStatusList] = useState(null)
    const [currentStatus, setCurrentStatus] = useState("");
    const [changedStatus, setChangedStatus] = useState("");
    const [fromDate, setFromDate] = useState(null);
    const [toDate, setToDate] = useState(null);
    const [minToDate, setMinToDate] = useState(null);
    const [disableGoButton, setDisableGoButton] = useState(null);
    const [emailBody, setEmailBody] = useState("");
    const [emailSubject, setEmailSubject] = useState("");
    const [emailBodyError, setEmailBodyError] = useState("");
    const [siteContactsList, setSiteContactsList] = useState(null);
    const [selectedSiteContacts, setSelectedSiteContacts] = useState(null);
    const [emailTo, setEmailTo] = useState("");
    const [emailToError, setEmailToError] = useState("");
    const [showAddSiteContactDialog, setShowAddSiteContactDialog] = useState(false);
    const [siteContactTitle, setSiteContactTitle] = useState("");
    const [siteContactFirstName, setSiteContactFirstName] = useState("");
    const [siteContactLastName, setSiteContactLastName] = useState("");
    const [siteContactPosition, setSiteContactPosition] = useState("");
    const [siteContactTelephone, setSiteContactTelephone] = useState("");
    const [siteContactMobile, setSiteContactMobile] = useState("");
    const [siteContactEmail, setSiteContactEmail] = useState("");
    const [siteContactComments, setSiteContactComments] = useState("");
    const [isPrimaryContact, setIsPrimaryContact] = useState(false);
    const [deleteSiteContactDialog, setDeleteSiteContactDialog] = useState(false);
    const [deleteSiteContact, setDeleteSiteContact] = useState(null);

    const [disablePDFViewer, setDisablePDFViewer] = useState(true);
    const [showPdfViewer, setShowPdfViewer] = useState(false);
    const [pdfLoadedMessage, setPdfLoadedMessage] = useState("First pending worksheet in the list is loaded");
    const [pdfUrl, setPdfUrl] = useState("");
    const [changedSubmissionStatusInPDFViewerVisible, setChangedSubmissionStatusInPDFViewerVisible] = useState(1);
    const [changeStatusDialogInPDFViewerVisible, setChangeStatusDialogInPDFViewerVisible] = useState(false);
    const [changeStatusDialogMessageInPDFViewer, setChangeStatusDialogMessageInPDFViewer] = useState("");
    const [showSiteRevisitStatusDialogInPDFViewerVisible, setShowSiteRevisitStatusDialogInPDFViewerVisible] = useState(false);
    const [showSiteAttentionStatusDialogInPDFViewerVisible, setShowSiteAttentionStatusDialogInPDFViewerVisible] = useState(false);
    const [showApproveStatusDialogInPDFViewerVisible, setShowApproveStatusDialogInPDFViewerVisible] = useState(false);
    const [showChangeStatusDialog, setShowChangeStatusDialog] = useState(false);
    const [fitters, setFitters] = useState(null);
    const [assignedTo, setAssignedTo] = useState(0);
    const [rescheduledDate, setRescheduledDate] = useState(null);
    const [rescheduledComments, setRescheduledComments] = useState("");
    const [minDate, setMinDate] = useState(null);
    const [loading, setLoading] = useState(false);
    const [dialogLoading, setDialogLoading] = useState(false);
    const [submitButtonDisable, setSubmitButtonDisable] = useState(false);

    const [completionDate, setCompletionDate] = useState(null);
    const [completionMaxDate, setCompletionMaxDate] = useState(null);
    const [selectedFitters, setSelectedFitters] = useState(null);
    const [disableRemoveFitterButton, setDisableRemoveFitterButton] = useState(true);
    const [selectedRemoveFitter, setSelectedRemoveFitter] = useState(null);
    const [showAddFitter, setShowAddFitter] = useState(false);
    const [disableAddButtonInAddFitterModal, setDisableAddButtonInAddFitterModal] = useState(true);
    const [selectedAddFitter, setSelectedAddFitter] = useState(null);
    const [quantity, setQuantity] = useState(0);
    const [wageValue, setWageValue] = useState(0);
    const [areWagesProcessed, setAreWagesProcessed] = useState(false);
    const [shouldProcessWages, setShouldProcessWages] = useState(false);
    const [addFitterFilters, setAddFitterFilters] = useState(null)
    const [addFitterGlobalFilterValue, setAddFitterGlobalFilterValue] = useState("");

    const [assignedToError, setAssignedToError] = useState(false);
    const [rescheduledCommentsError, setRescheduledCommentsError] = useState(false);

    const [filters, setFilters] = useState(null);
    const [globalFilterValue, setGlobalFilterValue] = useState("");

    const getFormattedDate = (dateToFormat) => {
        const year = dateToFormat.getFullYear();
        const month = String(dateToFormat.getMonth() + 1).padStart(2, "0");
        const day = String(dateToFormat.getDate()).padStart(2, "0");
        const formatedDate = `${year}-${month}-${day}`;
        return formatedDate;
    }

    const getSiteContacts = async () => {
        const systemId = showPdfViewer ? currentPendingWorksheet.systemId : toBeStatusChangedWorksheet.systemId
        const requestData = {
            systemId: systemId
        };
        const endPoint = SERVICE_LOCATION + GET_SITE_CONTACTS_BY_SYSTEMID;
        await axios.post(endPoint, requestData, {
            headers: {
                Authorization: `Bearer ${data.data.token}`,
            },
        })
            .then((response) => {
                if (response.data.isSuccess) {
                    setSiteContactsList(response.data.data.siteContacts);
                }
                else if (!response.data.isSuccess) {
                    setSiteContactsList(null);
                    toast.current.show({ severity: "error", summary: "Error", detail: response.data.errorMessage, life: 3000 });
                }
            })
            .catch((error) => {
                setSiteContactsList(null);
                toast.current.show({ severity: "error", summary: "Error", detail: error, life: 3000 });
            })
    }

    const addSiteContacts = async () => {
        var addSiteContactsRequest = [];
        siteContactsList.forEach(siteContact => {
            if (siteContact.isAddSiteContact) {
                const sc = {
                    systemId: siteContact.systemId,
                    title: siteContact.title,
                    firstName: siteContact.firstName,
                    lastName: siteContact.lastName,
                    position: siteContact.position,
                    telephone: siteContact.telephone,
                    mobile: siteContact.mobile,
                    email: siteContact.email,
                    comments: siteContact.comments,
                    isPrimaryContact: siteContact.isPrimaryContact,
                    isAddSiteContact: true
                }
                addSiteContactsRequest.push(sc);
            }
        })
        if (addSiteContactsRequest.length > 0) {
            const addSiteContactsEndPoint = SERVICE_LOCATION + ADD_SITE_CONTACTS;
            await axios.post(addSiteContactsEndPoint, addSiteContactsRequest, {
                headers: {
                    Authorization: `Bearer ${data.data.token}`,
                },
            })
                .then((response) => {
                    if (response.data.isSuccess) {
                        onHideAddSiteContactsDialog();
                        setShowAddSiteContactDialog(false);
                    }
                    else if (!response.data.isSuccess) {
                        toast.current.show({ severity: "error", summary: "Error", detail: response.data.errorMessage, life: 5000 });
                    }
                })
                .catch((error) => {
                    toast.current.show({ severity: "error", summary: "Error", detail: error, life: 3000 });
                })
        }
    }

    const getFitters = async () => {
        const requestData = {
            depot: userDepot
        }
        const endPoint = SERVICE_LOCATION + GET_FITTERS_API;
        await axios.post(endPoint, requestData, {
            headers: {
                Authorization: `Bearer ${data.data.token}`,
            },
        })
            .then((response) => {
                if (response.data.isSuccess) {
                    const liveFitterDetails = (response.data.data.fitterDetails).filter(item => item.isActive === 'Y');
                    setFitters(liveFitterDetails);
                    //setFitters(response.data.data.fitterDetails);
                }
                else if (!response.data.isSuccess) {
                    toast.current.show({ severity: "error", summary: "Error", detail: response.data.errorMessage, life: 3000 });
                }
            })
            .catch((error) => {
                toast.current.show({ severity: "error", summary: "Error", detail: error, life: 3000 });
            })
    }

    const getWorkSheets = (selectedFromDate, selectedToDate) => {
        setLoading(true);
        const formatedFromDate = getFormattedDate(selectedFromDate);
        const formatedToDate = getFormattedDate(selectedToDate)
        const requestedData = {
            StartDate: formatedFromDate,
            EndDate: formatedToDate,
            Depot: userDepot
        }
        const endPoint = SERVICE_LOCATION + GET_WORKSHEETS_BETWEEN_DATES;
        axios.post(endPoint, requestedData, {
            headers: {
                Authorization: `Bearer ${data.data.token}`,
            },
        }).then((response) => {
            setselectedWorksheets(null);
            if (response.data.isSuccess) {
                const processedData = response.data.data.calledOffWorkSheets;
                setWorksheets(processedData);

                var filteredPendingWorksheets = processedData.filter((item) => item.submissionStatus === "Pending")
                setPendingWorksheets(filteredPendingWorksheets)
                if (filteredPendingWorksheets.length > 0) {
                    setDisablePDFViewer(false);
                    if (showPdfViewer) {
                        if (filteredPendingWorksheets.length === 1) {
                            setPdfLoadedMessage("Last pending worksheet in the list is loaded");
                        }
                        setCurrentPendingWorksheet(filteredPendingWorksheets[0]);
                        loadPendingWorksheetAsPDF(filteredPendingWorksheets[0].submissionId);
                    }
                } else {
                    setDisablePDFViewer(true);
                    setShowPdfViewer(false);
                }
            }
            else if (!response.data.isSuccess) {
                setWorksheets(null);
                setDisablePDFViewer(true);
            }
            setDisableDownloadButton(true);
            setLoading(false);
        }).catch((error) => {
            setLoading(false);
            toast.current.show({ severity: "error", summary: "Error", detail: error, life: 3000 });
        })
    }

    const getSubmissionStatus = async () => {
        const endPoint = SERVICE_LOCATION + GET_SUBMISSION_STATUS;
        await axios.get(endPoint, {
            headers: {
                Authorization: `Bearer ${data.data.token}`,
            },
        })
            .then((response) => {
                if (response.data.isSuccess) {
                    let filteredStatusList = (response.data.data.submissionStatus).filter(item => item.status !== toBeStatusChangedWorksheet.submissionStatus);
                    setSubmissionStatusList(filteredStatusList);
                }
                else if (!response.data.isSuccess) {
                    toast.current.show({ severity: "error", summary: "Error", detail: response.data.errorMessage, life: 3000 });
                }
            })
            .catch((error) => {
                toast.current.show({ severity: "error", summary: "Error", detail: error, life: 3000 });
            })
    }

    const getFitterDetailsForMeasure = () => {
        const requestData = {
            measureId: showPdfViewer ? currentPendingWorksheet.measureId : toBeStatusChangedWorksheet.measureId
        };
        const endPoint = SERVICE_LOCATION + GET_WAGES_FOR_MEASURE;
        axios.post(endPoint, requestData, {
            headers: {
                Authorization: `Bearer ${data.data.token}`,
            },
        })
            .then((response) => {
                if (response.data.isSuccess) {
                    var wagesForMeasure = response.data.data.wages;
                    var fittersObj = [];
                    const fitterObj = {
                        fitterId: wagesForMeasure.fitterId,
                        fitterName: wagesForMeasure.fitterName,
                        workShare: "100"
                    }
                    fittersObj.push(fitterObj);
                    setQuantity(wagesForMeasure.quantity);
                    setWageValue(wagesForMeasure.wageValue);
                    setSelectedFitters(fittersObj);
                }
                else if (!response.data.isSuccess) {
                    toast.current.show({ severity: "error", summary: "Error", detail: response.data.errorMessage, life: 3000 });
                }
            })
            .catch((error) => {
                toast.current.show({ severity: "error", summary: "Error", detail: error, life: 3000 });
            })
    }

    const checkIfWagesProcess = async (isPDFViewerUpdate) => {
        const requestData = {
            measureId: isPDFViewerUpdate ? currentPendingWorksheet.measureId : toBeStatusChangedWorksheet.measureId
        }
        const endPoint = SERVICE_LOCATION + CHECK_IF_WAGES_PROCESSED;
        await axios.post(endPoint, requestData, {
            headers: {
                Authorization: `Bearer ${data.data.token}`,
            },
        })
            .then((response) => {
                if (response.data.isSuccess) {
                    if (response.data.data.areWagesProcessed) {
                        setChangeStatusDialogMessageInPDFViewer(response.data.data.notes);
                        setAreWagesProcessed(response.data.data.areWagesProcessed);
                    }
                    else {
                        handleShowWageProcess();
                        setChangeStatusDialogMessageInPDFViewer("Are you sure you want to process the wages and approve this worksheet?");
                        setAreWagesProcessed(false);
                    }
                }
                else if (!response.data.isSuccess) {
                    toast.current.show({ severity: "error", summary: "Error", detail: response.data.errorMessage, life: 3000 });
                }
            })
            .catch((error) => {
                toast.current.show({ severity: "error", summary: "Error", detail: error, life: 3000 });
            })
    }

    useEffect(() => {
        if (data !== undefined) {
            const currentDate = new Date();
            const previousDate = new Date(currentDate);
            previousDate.setDate(currentDate.getDate() - 2);
            setFromDate(previousDate);
            setToDate(currentDate);
            setRescheduledDate(currentDate);
            getWorkSheets(previousDate, currentDate);
            getFitters();
            initFilters();
            initAddFitterFilters();
        } else {
            navigate("/login");
        }
    }, []);

    const handlePDFDownload = async () => {
        setLoading(true);
        var selectedSubmissions = [];
        selectedWorksheets.forEach(worksheet => {
            const submission = {
                submissionId: worksheet.submissionId
            }
            selectedSubmissions.push(submission);
        })
        const endPoint = SERVICE_LOCATION + DOWNLOAD_SUBMITTED_WORKSHEETS;
        await axios.post(endPoint, selectedSubmissions, {
            headers: {
                Authorization: `Bearer ${data.data.token}`,
            },
        }).then((response) => {
            setLoading(false);
            if (response.data.isSuccess) {
                if (response.data.data.downloadedWorkCards.length > 0) {
                    (response.data.data.downloadedWorkCards).forEach(workcard => {
                        const base64 = workcard.chunks.join("");
                        const base64String = "data:application/pdf;base64," + base64;
                        const linkSource = base64String;
                        const downloadLink = document.createElement("a");
                        const fileName = workcard.fileName;
                        downloadLink.href = linkSource;
                        downloadLink.download = fileName;
                        downloadLink.click();
                    });
                }
                toast.current.show({ severity: "success", summary: "Success", detail: WORKCARDS_DOWNLOADED, life: 5000 });
            }
            else if (!response.data.isSuccess) {
                toast.current.show({ severity: "error", summary: "Error", detail: response.data.errorMessage, life: 5000 });
            }
        }).catch((error) => {
            setLoading(false);
            toast.current.show({ severity: "error", summary: "Error", detail: error, life: 5000 });
        })
    }

    const handleWorksheetSelection = (e) => {
        setselectedWorksheets(e.value);
        e.value.length > 0 ? setDisableDownloadButton(false) : setDisableDownloadButton(true);
        if ((e.value).length === 1) {
            setDisableChangeStatusButton(false);
            setToBeStatusChangedWorksheet((e.value)[0]);
        } else {
            setDisableChangeStatusButton(true);
            setToBeStatusChangedWorksheet(null);
        }

        //logic to enable upload customer payment form
        if (e.value.length > 0) {
            const isOneClient = ((e.value).every(c => c.clientAccount === ((e.value)[0]).clientAccount));
            if (isOneClient && ((e.value)[0]).paymentFormRequired === "Yes")
                setDisableUploadPaymentFormButton(false)
            else
                setDisableUploadPaymentFormButton(true);
        }
        else {
            setDisableUploadPaymentFormButton(true);
        }
    }

    const handleSiteContactSelection = (e) => {
        setSelectedSiteContacts(e.value);
        var strEmailTo = "";
        (e.value).forEach(sc => {
            if (sc.email !== "") {
                strEmailTo = strEmailTo + sc.email + ";\n";
            }
        });
        setEmailTo(strEmailTo);
    }

    const handleGo = () => {
        getWorkSheets(fromDate, toDate);
    }

    const handleFromDate = (e) => {
        const dateSelected = e.value;
        setFromDate(dateSelected);
        setMinToDate(dateSelected);
        setToDate(null);
        setDisableGoButton(true);
    }

    const handleToDate = (e) => {
        const dateSelected = e.value;
        setToDate(dateSelected);
        setDisableGoButton(false);
    }

    const handleShowAddSiteContact = () => {
        setShowAddSiteContactDialog(true);
    }

    // Search functionality
    const clearFilter = () => {
        initFilters();
    };

    const initFilters = () => {
        setFilters({
            global: { value: null, matchMode: FilterMatchMode.CONTAINS },
            clientName: { value: null, matchMode: FilterMatchMode.CONTAINS },
            paymentFormRequired: { value: null, matchMode: FilterMatchMode.CONTAINS },
            siteName: { value: null, matchMode: FilterMatchMode.CONTAINS },
            siteAddress: { value: null, matchMode: FilterMatchMode.CONTAINS },
            siteTelNo: { value: null, matchMode: FilterMatchMode.CONTAINS },
            plotNumber: { value: null, matchMode: FilterMatchMode.CONTAINS },
            plotDescription: { value: null, matchMode: FilterMatchMode.CONTAINS },
            worksheetNo: { value: null, matchMode: FilterMatchMode.CONTAINS },
            measureStatus: { value: null, matchMode: FilterMatchMode.CONTAINS },
            measureCode: { value: null, matchMode: FilterMatchMode.CONTAINS },
            measureDescription: { value: null, matchMode: FilterMatchMode.CONTAINS },
            measureType: { value: null, matchMode: FilterMatchMode.CONTAINS },
            planDate: { value: null, matchMode: FilterMatchMode.CONTAINS },
            crew: { value: null, matchMode: FilterMatchMode.CONTAINS },
            depot: { value: null, matchMode: FilterMatchMode.CONTAINS },
            resourceCode: { value: null, matchMode: FilterMatchMode.CONTAINS },
            submissionStatus: { value: null, matchMode: FilterMatchMode.CONTAINS },
            isSubmitted: { value: null, matchMode: FilterMatchMode.CONTAINS },
            submissionStatusUpdatedBy: { value: null, matchMode: FilterMatchMode.CONTAINS },
            isPaperworkUploaded: { value: null, matchMode: FilterMatchMode.CONTAINS }
        });
        setGlobalFilterValue("");
    }

    const renderSiteContactsHeader = () => {
        return (
            <div className="row">
                <div className="col-12 col-sm-4 col-md-4 col-lg-4 col-xl-4">
                    <Button id="add-site-contact" label="Add Site Contact" onClick={handleShowAddSiteContact}>Add Site Contact</Button>
                </div>
            </div>
        )
    }

    const renderHeader = () => {
        return (
            <div className="row">
                <div className="col-12 col-sm-2 col-md-2 col-lg-2 col-xl-2">
                    <label htmlFor="from-date">From</label>
                    <Calendar id="from-date" name="from-date" value={fromDate} onChange={handleFromDate} showIcon dateFormat="dd/mm/yy" />
                </div>
                <div className="col-12 col-sm-2 col-md-2 col-lg-2 col-xl-2">
                    <label htmlFor="to-date">To</label>
                    <Calendar id="to-date" name="to-date" value={toDate} onChange={handleToDate} minDate={minToDate} showIcon dateFormat="dd/mm/yy" />
                </div>
                <div className="col-12 col-sm-1 col-md-1 col-lg-1 col-xl-1 padt-23">
                    <Button id="go" label="Go" disabled={disableGoButton} onClick={handleGo}>GO</Button>
                </div>
                <div className="col-12 col-sm-7 col-md-7 col-lg-7 col-xl-7 padt-15">
                    <div className="flex justify-content-end txt-right">
                        <PrimeButton className="mar-r-10" type="button" icon="pi pi-filter-slash" label="Clear" outlined onClick={clearFilter} tooltip="clear filters" tooltipOptions={{ position: "bottom" }} />
                        <span className="p-input-icon-left">
                            <i className="pi pi-search" />
                            <InputText value={globalFilterValue} onChange={onGlobalFilterChange} placeholder="Keyword Search" />
                        </span>
                    </div>
                </div>
            </div>
        );
    };

    const onGlobalFilterChange = (e) => {
        const value = e.target.value;
        let _filters = { ...filters };

        _filters["global"].value = value;

        setFilters(_filters);
        setGlobalFilterValue(value);
    };

    const header = renderHeader();
    const siteContactsHeader = renderSiteContactsHeader();
    // Search functionality Ends here

    // To disbale unsubmitted worksheets to prevent from download
    const isSelectable = (data) => data.isSubmitted === "Y";
    const isRowSelectable = (event) => (event.data ? isSelectable(event.data) : true);
    const rowClassName = (data) => (isSelectable(data) ? "" : "p-disabled");
    // Disable functionality Ends here

    // Staus severity with colors for submission status
    const getStatusSeverity = (submissionStatus) => {
        switch (submissionStatus) {
            case "Approved":
                return "approve";
            case "Site Attention":
                return "attention";
            case "Site Revisit":
                return "revisit";
            case "Pending":
                return "pending";
            default:
                return "nocolor";
        }
    };

    const statusBodyTemplate = (worksheet) => {
        return <span className={`status-severity ${getStatusSeverity(worksheet.submissionStatus)}`}>{worksheet.submissionStatus}</span>
    };
    // Staus severity with colors for submission status ends here

    const handleHidePDFViewer = () => {
        setShowPdfViewer(false);
        setPdfLoadedMessage("First worksheet in the list is loaded");
    }

    const handleStatusDialogVisibilityInPDFViewer = () => {
        const currentDate = new Date();
        setShowApproveStatusDialogInPDFViewerVisible(false);
        setShowSiteRevisitStatusDialogInPDFViewerVisible(false);
        setShowSiteAttentionStatusDialogInPDFViewerVisible(false);
        setRescheduledComments("");
        setRescheduledDate(currentDate);
        setAssignedTo(0);
        setSelectedSiteContacts(null);
        setEmailBody("");
        setEmailTo("");
        setEmailSubject("");
        setSelectedAddFitter(null);
        setSelectedRemoveFitter(null);
        setSubmitButtonDisable(false);
    }

    const handleShowChangeStatusDialog = () => {
        getSubmissionStatus();
        setShowChangeStatusDialog(true);
        setCurrentStatus(toBeStatusChangedWorksheet.submissionStatus)
    }

    const saveChangeStatus = (isPDFViewerUpdate) => {
        setSubmitButtonDisable(true);
        const newStatus = isPDFViewerUpdate ? SUBMISSION_STATUS[changedSubmissionStatusInPDFViewerVisible] : changedStatus.status;

        if (newStatus === "Pending") {
            updateChangedStatus();
        }
        else if (newStatus === "Approved") {
            areWagesProcessed ? updateChangedStatus() : handleSaveWages(isPDFViewerUpdate);
        }
        else if (newStatus === "Site Revisit") {
            assignedTo === 0 ? setAssignedToError(true) : setAssignedToError(false);
            rescheduledComments.trim() === "" ? setRescheduledCommentsError(true) : setRescheduledCommentsError(false);
            if (assignedTo === undefined || assignedTo === 0 || rescheduledComments.trim() === "") {
                setSubmitButtonDisable(false);
                toast.current.show({ severity: "error", summary: "Error", detail: COMPLETE_ALL_FIELDS, life: 5000 });
            }
            else {
                shouldProcessWages ? handleSaveWages(isPDFViewerUpdate) : handleRevisitStatus(isPDFViewerUpdate);
            }
        }
        else if (newStatus === "Site Attention") {
            emailBody === "" ? setEmailBodyError(true) : setEmailBodyError(false);
            emailTo === "" ? setEmailToError(true) : setEmailToError(false);
            if (emailBody === "" || emailTo === "") {
                toast.current.show({ severity: "error", summary: "Error", detail: COMPLETE_ALL_FIELDS, life: 5000 });
            }
            else {
                shouldProcessWages ? handleSaveWages(isPDFViewerUpdate) : handleSiteAttentionStatus(isPDFViewerUpdate);
            }
        }
    }

    const handlePDFViewer = () => {
        var pendingWorksheetCount = pendingWorksheets.length;
        if (pendingWorksheetCount > 0) {
            if (pendingWorksheetCount === 1) {
                setPdfLoadedMessage("Last pending worksheet in the list is loaded");
            }
            setCurrentPendingWorksheet(pendingWorksheets[0]);
            loadPendingWorksheetAsPDF(pendingWorksheets[0].submissionId);
        }
        else {
            setPdfLoadedMessage("First pending worksheet in the list is loaded");
            setShowPdfViewer(false);
        }
    }

    const loadPendingWorksheetAsPDF = (submissionId) => {
        setLoading(true);
        var selectedSubmissions = [];
        const submission = {
            submissionId: submissionId
        }
        selectedSubmissions.push(submission);
        const endPoint = SERVICE_LOCATION + DOWNLOAD_SUBMITTED_WORKSHEETS;
        axios.post(endPoint, selectedSubmissions, {
            headers: {
                Authorization: `Bearer ${data.data.token}`,
            },
        })
            .then((response) => {
                setLoading(false);
                setDialogLoading(false);
                if (response.data.isSuccess) {
                    if (response.data.data.downloadedWorkCards.length === 1) {
                        const base64 = (response.data.data.downloadedWorkCards[0]).chunks.join("");
                        const byteCharacters = atob(base64);
                        const byteNumbers = new Array(byteCharacters.length);
                        for (let i = 0; i < byteCharacters.length; i++) {
                            byteNumbers[i] = byteCharacters.charCodeAt(i);
                        }
                        const byteArray = new Uint8Array(byteNumbers);
                        const blob = new Blob([byteArray], { type: "application/pdf" });
                        const url = URL.createObjectURL(blob);
                        setPdfUrl(url);

                        setShowPdfViewer(true);
                    }
                    else {
                        setPdfUrl("");
                    }
                }
                else if (!response.data.isSuccess) {
                    toast.current.show({ severity: "error", summary: "Error", detail: response.data.errorMessage, life: 5000 });
                }
            })
            .catch((error) => {
                setLoading(false);
                setDialogLoading(false);
                toast.current.show({ severity: "error", summary: "Error", detail: error, life: 5000 });
            })
    }

    const updateChangedStatus = () => {
        const formatedRescheduledDate = getFormattedDate(rescheduledDate);
        var selectedSubmissions = [];
        let emailList = emailTo.split(";\n");
        let finalEmailList = emailList.slice(0, -1);    //to remove the empty record which is created at the end
        const submission = {
            submissionId: toBeStatusChangedWorksheet.submissionId,
            measureId: toBeStatusChangedWorksheet.measureId,
            submissionStatus: changedStatus.id,
            submittedBy: userName,
            rescheduledDate: formatedRescheduledDate,
            assignedTo: changedStatus.status === "Site Revisit" ? assignedTo.fitterId : 0,
            rescheduledComments: rescheduledComments,
            emailTo: finalEmailList,
            emailBody: emailBody,
            emailSubject: emailSubject
        }
        selectedSubmissions.push(submission);

        const endPoint = SERVICE_LOCATION + UPDATE_SUBMISSION_STATUS;
        axios.post(endPoint, selectedSubmissions, {
            headers: {
                Authorization: `Bearer ${data.data.token}`,
            },
        })
            .then((response) => {
                if (response.data.isSuccess) {
                    clearChangeStatusDialog();
                    getWorkSheets(fromDate, toDate);
                    if (changedStatus.status === "Site Attention") {
                        addSiteContacts();
                    }
                    toast.current.show({ severity: "success", summary: "Success", detail: response.data.data, life: 5000 });
                }
                else if (!response.data.isSuccess) {
                    toast.current.show({ severity: "error", summary: "Error", detail: response.data.errorMessage, life: 5000 });
                }
            })
            .catch((error) => {
                toast.current.show({ severity: "error", summary: "Error", detail: error, life: 5000 });
            })
    }

    const clearChangeStatusDialog = () => {
        setShowChangeStatusDialog(false);
        setDisableChangeStatusButton(true);
        setDisableUploadPaymentFormButton(true);
        setChangedStatus("");
        setSubmitButtonDisable(false);
        handleStatusDialogVisibilityInPDFViewer();
    }

    const handleHideChangeStatusDialouge = () => {
        setShowChangeStatusDialog(false);
        setChangedStatus("");
        handleStatusDialogVisibilityInPDFViewer();
    }

    const handleWorksheetSubmissionStatus = () => {
        setDialogLoading(true);
        var selectedSubmissions = [];
        let emailList = emailTo.split(";\n");
        let finalEmailList = emailList.slice(0, -1);
        const formatedRescheduledDate = getFormattedDate(rescheduledDate);
        const submission = {
            submissionId: currentPendingWorksheet.submissionId,
            measureId: currentPendingWorksheet.measureId,
            submissionStatus: changedSubmissionStatusInPDFViewerVisible,
            submittedBy: userName,
            rescheduledDate: formatedRescheduledDate,
            assignedTo: changedSubmissionStatusInPDFViewerVisible === 3 ? assignedTo.fitterId : 0,
            rescheduledComments: rescheduledComments,
            emailTo: finalEmailList,
            emailBody: emailBody,
            emailSubject: emailSubject
        }
        selectedSubmissions.push(submission);
        const endPoint = SERVICE_LOCATION + UPDATE_SUBMISSION_STATUS;
        axios.post(endPoint, selectedSubmissions, {
            headers: {
                Authorization: `Bearer ${data.data.token}`,
            },
        })
            .then((response) => {
                if (response.data.isSuccess) {
                    toast.current.show({ severity: "success", summary: "Success", detail: response.data.data, life: 5000 });
                    setPdfLoadedMessage("Next pending worksheet in the list is loaded");
                    handleStatusDialogVisibilityInPDFViewer();
                }
                else if (!response.data.isSuccess) {
                    toast.current.show({ severity: "error", summary: "Error", detail: response.data.errorMessage, life: 5000 });
                }
                getWorkSheets(fromDate, toDate);
                if (changedSubmissionStatusInPDFViewerVisible === 4) {
                    addSiteContacts();
                }
            })
            .catch((error) => {
                toast.current.show({ severity: "error", summary: "Error", detail: error, life: 5000 });
                getWorkSheets(fromDate, toDate);
            })
    }

    const handleStatusButtonClick = (status) => {
        setShouldProcessWages(false);
        setChangedSubmissionStatusInPDFViewerVisible(status);
        checkIfWagesProcess(true);
        if (status === 3) {
            setChangeStatusDialogMessageInPDFViewer("Are you sure site revisit is required for this worksheet?");
        }
        else if (status === 4) {
            setChangeStatusDialogMessageInPDFViewer("Are you sure site attention is needed for this worksheet?");
        }
        setChangeStatusDialogInPDFViewerVisible(true);
    }

    const handleChangedStatusDropdown = (e) => {
        setShouldProcessWages(false);
        setChangedStatus(e.value)
        var status = (e.value).status;
        checkIfWagesProcess(false);
        if (status === "Site Attention") {
            getSiteContacts();
            var strEmailBody = `<p>Greetings,</p><p><br></p><p>Our records show we have worksheets requiring your sign off on site <strong>${toBeStatusChangedWorksheet.siteName}.</strong></p><p><br></p><p>Please follow the provided link and sign off the work to allow us to send you a copy of the completed worksheet in due course.</p><p><a style="cursor: pointer" href="https://eeg-clientportal.azurewebsites.net/" target="#">Client Portal</a></p><p><br></p><p>Kindest Regards,</p><p>Max Energy</p>`;
            setEmailBody(strEmailBody);

            var strEmailSubject = `Max Energy - Worksheet Requiring Your Attention`;
            setEmailSubject(strEmailSubject);
        }
    }

    const handleSiteAttentionStatus = (isPDFViewerUpdate) => {
        isPDFViewerUpdate ? handleWorksheetSubmissionStatus() : updateChangedStatus();
    }

    const handleRevisitStatus = (isPDFViewerUpdate) => {
        isPDFViewerUpdate ? handleWorksheetSubmissionStatus() : updateChangedStatus();
    }

    const accept = () => {
        if (changedSubmissionStatusInPDFViewerVisible === 2) {
            areWagesProcessed ? handleWorksheetSubmissionStatus() : setShowApproveStatusDialogInPDFViewerVisible(true);
        }
        else if (changedSubmissionStatusInPDFViewerVisible === 3) {
            const today = new Date();
            setMinDate(today);
            setShowSiteRevisitStatusDialogInPDFViewerVisible(true);
        }
        else if (changedSubmissionStatusInPDFViewerVisible === 4) {
            getSiteContacts();
            var strEmailBody = `<p>Greetings,</p><p><br></p><p>Our records show we have worksheets requiring your sign off on site <strong>${currentPendingWorksheet.siteName}.</strong></p><p><br></p><p>Please follow the provided link and sign off the work to allow us to send you a copy of the completed worksheet in due course.</p><p><a style="cursor: pointer" href="https://eeg-clientportal.azurewebsites.net/" target="#">Client Portal</a></p><p><br></p><p>Kindest Regards,</p><p>Max Energy</p>`;
            setEmailBody(strEmailBody);

            var strEmailSubject = `Site Attention Required: ${currentPendingWorksheet.siteName} Plot-${currentPendingWorksheet.plotNumber}`;
            setEmailSubject(strEmailSubject);
            setShowSiteAttentionStatusDialogInPDFViewerVisible(true);
        }
    }

    const reject = () => {
        toast.current.show({ severity: "warn", summary: "Rejected", detail: "You have rejected", life: 3000 });
    }

    const handleRescheduledDateChange = (e) => {
        const dateSelected = e.value;
        setRescheduledDate(dateSelected);
    }

    const handleOnAddSiteContact = () => {
        var allSiteContacts = siteContactsList ?? [];
        const maxId = (allSiteContacts ?? []).reduce((max, obj) => (obj.id > max ? obj.id : max), 0)
        const siteContact = {
            id: maxId + 1,
            systemId: showPdfViewer ? currentPendingWorksheet.systemId : toBeStatusChangedWorksheet.systemId,
            title: siteContactTitle.title,
            firstName: siteContactFirstName,
            lastName: siteContactLastName,
            position: siteContactPosition,
            telephone: siteContactTelephone,
            mobile: siteContactMobile,
            email: siteContactEmail,
            comments: siteContactComments,
            isPrimaryContact: isPrimaryContact ? "Y" : "N",
            isAddSiteContact: true
        }
        allSiteContacts.push(siteContact);
        setSiteContactsList(allSiteContacts);
        onHideAddSiteContactsDialog();
    }

    const confirmDeleteContact = (rowData) => {
        setDeleteSiteContactDialog(true);
        setDeleteSiteContact(rowData);
    }

    const handleDeleteSiteContact = () => {
        let allContacts = siteContactsList.filter((val) => val.id !== deleteSiteContact.id);
        setSiteContactsList(allContacts);
        toast.current.show({ severity: "success", summary: "Success", detail: "succesfully deleted the newly created site contact", life: 3000 });
        setDeleteSiteContactDialog(false);
    }

    const onHideAddSiteContactsDialog = () => {
        setSiteContactTitle("");
        setSiteContactFirstName("");
        setSiteContactLastName("");
        setSiteContactTelephone("");
        setSiteContactMobile("");
        setSiteContactEmail("");
        setSiteContactComments("");
        setSiteContactPosition("");
        setIsPrimaryContact(false);
        setShowAddSiteContactDialog(false);
    }

    const handleApproveStatusInPDFViewer = () => {
        areWagesProcessed ? handleWorksheetSubmissionStatus() : handleSaveWages(true);
    }

    const approveStatusfooterContentInPDFViewer = (
        <div>
            <PrimeButton label="Exit" size="small" onClick={handleStatusDialogVisibilityInPDFViewer} severity="secondary" outlined />
            <PrimeButton label={submitButtonDisable ? "Processing.." : "Submit"} size="small" disabled={submitButtonDisable} onClick={handleApproveStatusInPDFViewer} severity="secondary" outlined />
        </div>
    )

    const siteRevisitAttentionStatusfooterContentInPDFViewer = (
        <div>
            <PrimeButton label="Exit" size="small" onClick={handleStatusDialogVisibilityInPDFViewer} severity="secondary" outlined />
            <PrimeButton label="Submit" size="small" onClick={() => saveChangeStatus(true)} severity="secondary" outlined />
        </div>
    );

    const changeStatusfooterContent = (
        <div>
            <PrimeButton label="Cancel" size="small" onClick={handleHideChangeStatusDialouge} severity="secondary" outlined />
            <PrimeButton label={submitButtonDisable ? "Processing" : "Submit"} size="small" onClick={() => saveChangeStatus(false)} severity="secondary" outlined />
        </div>
    );

    const addSiteContactfooterContent = (
        <div>
            <PrimeButton label="Exit" size="small" onClick={onHideAddSiteContactsDialog} severity="secondary" outlined />
            <PrimeButton label="Submit" size="small" onClick={handleOnAddSiteContact} severity="secondary" outlined />
        </div>
    );

    const deleteProductDialogFooter = (
        <div>
            <PrimeButton label="No" size="small" onClick={() => setDeleteSiteContactDialog(false)} severity="secondary" outlined />
            <PrimeButton label="Yes" size="small" onClick={handleDeleteSiteContact} severity="danger" outlined />
        </div>
    )

    const deleteBodyTemplate = (rowData) => {
        if (rowData.isAddSiteContact) {
            return (
                <div>
                    <PrimeButton icon="pi pi-trash" rounded outlined severity="danger" onClick={() => confirmDeleteContact(rowData)} />
                </div>
            );
        } else {
            return (
                <div></div>
            );
        }
    };

    //Change to Approved Status

    // add fitters search functionality
    const clearAddFitterFilter = () => {
        initAddFitterFilters();
    }

    const initAddFitterFilters = () => {
        setAddFitterFilters({
            global: { value: null, matchMode: FilterMatchMode.CONTAINS },
            fitterId: { value: null, matchMode: FilterMatchMode.CONTAINS },
            fullName: { value: null, matchMode: FilterMatchMode.CONTAINS }
        });
        setAddFitterGlobalFilterValue("");
    }

    const renderAddFitterHeader = () => {
        return (
            <div className="row">
                <div className={"col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12"}>
                    <div className="flex justify-content-end txt-right">
                        <PrimeButton className="mar-r-10" type="button" size="small" icon="pi pi-filter-slash" label="Clear" outlined onClick={clearAddFitterFilter} tooltip="clear filters" tooltipOptions={{ position: "bottom" }} />
                        <span className="p-input-icon-left">
                            <i className="pi pi-search" />
                            <InputText value={addFitterGlobalFilterValue} onChange={onGlobalAddFitterFilterChange} className="p-inputtext-sm" placeholder="Keyword Search" />
                        </span>
                    </div>
                </div>
            </div>
        )
    }

    const onGlobalAddFitterFilterChange = (e) => {
        const value = e.target.value;
        let _filters = { ...addFitterFilters };

        _filters["global"].value = value;

        setAddFitterFilters(_filters);
        setAddFitterGlobalFilterValue(value);
    };

    const addFitterHeader = renderAddFitterHeader();
    // add fitters search functionality ends here  

    // edit wageshare
    const workShareEditor = (options) => {
        const handleInputChange = (e) => {
            const value = e.target.value;
            const regex = /^[0-9.]*$/;
            if (regex.test(value) || value === "" || value === ".") {
                options.editorCallback(value);
            }
        };

        return (
            <InputText type="text" className="p-inputtext-sm" value={options.value} onChange={handleInputChange} />
        );
    }
    // edit wageshare ends here

    const handleShowWageProcess = () => {
        const currentDate = new Date();
        const yesterdaysDate = new Date(currentDate);
        yesterdaysDate.setDate(currentDate.getDate() - 1);
        setCompletionDate(yesterdaysDate);
        setCompletionMaxDate(currentDate);
        setDisableRemoveFitterButton(true);
        getFitterDetailsForMeasure();
    }

    const handleSaveWages = (isPDFViewerUpdate) => {
        setSubmitButtonDisable(true);
        const totalWorkShare = selectedFitters.reduce((total, obj) => total + parseFloat(obj.workShare), 0);
        if (totalWorkShare === 100) {
            processWages(isPDFViewerUpdate);
        }
        else {
            setSubmitButtonDisable(false);
            toast.current.show({ severity: "error", summary: "Error", detail: WORK_SHARE_100_PERCENT, life: 3000 });
        }
    }

    const handleAddFitter = () => {
        var tempSelectedFitter = selectedFitters;
        const ifFitterExists = tempSelectedFitter.filter(f => f.fitterId === selectedAddFitter.fitterId);
        if (ifFitterExists.length === 0) {
            const fitterObj = {
                fitterId: selectedAddFitter.fitterId,
                fitterName: selectedAddFitter.fullName,
                workShare: "100"
            }
            tempSelectedFitter.push(fitterObj);
            const percentageWorkShare = 100 / tempSelectedFitter.length;

            let updatedSelectedFitters = tempSelectedFitter.map(f => { return { ...f, workShare: percentageWorkShare.toFixed(2) } });
            setSelectedAddFitter(null);
            setSelectedFitters(updatedSelectedFitters);
        }
        setShowAddFitter(false);
    }

    const addFitterFooterContent = (
        <div className="padt-10">
            <PrimeButton label="Cancel" size="small" icon="pi pi-times" onClick={() => setShowAddFitter(false)} className="p-button-text" />
            <PrimeButton label="Add" size="small" icon="pi pi-check" disabled={disableAddButtonInAddFitterModal} onClick={handleAddFitter} autoFocus />
        </div>
    )

    const handleFitterSelectionInAddFitterModal = (e) => {
        setSelectedAddFitter(e.value);
        setDisableAddButtonInAddFitterModal(false);
    }

    const processWages = (isPDFViewerUpdate) => {
        let selectedMeasureIds = [];
        isPDFViewerUpdate ? selectedMeasureIds.push(currentPendingWorksheet.measureId) : selectedMeasureIds.push(toBeStatusChangedWorksheet.measureId);
        const workShare = selectedFitters.map(({ fitterId, workShare }) => ({ fitterId, workShare }));
        const requestData = {
            completionDate: getFormattedDate(completionDate),
            processedBy: userName,
            measureIds: selectedMeasureIds,
            workShare: workShare
        }
        const endPoint = SERVICE_LOCATION + PROCESS_WAGES;
        axios.post(endPoint, requestData, {
            headers: {
                Authorization: `Bearer ${data.data.token}`,
            },
        })
            .then((response) => {
                if (response.data.isSuccess) {
                    isPDFViewerUpdate ? handleWorksheetSubmissionStatus() : updateChangedStatus();
                }
                else if (!response.data.isSuccess) {
                    toast.current.show({ severity: "error", summary: "Error", detail: response.data.errorMessage, life: 3000 });
                }
            })
            .catch((error) => {
                toast.current.show({ severity: "error", summary: "Error", detail: error, life: 3000 });
            })
    }

    const handleRemoveFitter = () => {
        let tempSelectedFitters = selectedFitters;
        const remainingFitters = tempSelectedFitters.filter(f => f.fitterId !== selectedRemoveFitter.fitterId);
        const percentageWorkShare = 100 / remainingFitters.length;
        let updatedSelectedFitters = remainingFitters.map(f => { return { ...f, workShare: percentageWorkShare.toFixed(2) } });
        setSelectedFitters(updatedSelectedFitters);
        setSelectedRemoveFitter(null);
        setDisableRemoveFitterButton(true);
    }

    const handleShowAddFiter = () => {
        setDisableAddButtonInAddFitterModal(true);
        setSelectedAddFitter(null);
        clearAddFitterFilter();
        setShowAddFitter(true);
    }

    const renderFittersHeader = () => {
        return (
            <div className="row">
                <div className="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
                    <div className="flex justify-content-end txt-right">
                        <Button className="mar-r-10" disabled={disableRemoveFitterButton} id="remove-fiter" onClick={handleRemoveFitter}>Remove Fitter</Button>
                        <Button className="mar-r-10" id="add-fiter" onClick={handleShowAddFiter}>Add Fitter</Button>
                    </div>
                </div>
            </div>
        );
    }
    const fittersHeader = renderFittersHeader();

    const handleRemoveFitterSelection = (e) => {
        if (selectedFitters.length > 1) {
            setDisableRemoveFitterButton(false);
            setSelectedRemoveFitter(e.value);
        }
    }
    //End Change to Approved Status

    //File Upload
    const handleFileUpload = () => {
        fileInputRef.current.click();
    };

    const handleFileChange = (event) => {
        const selectedFile = event.target.files[0];
        if (!selectedFile) return;

        const isPdf = selectedFile.type === "application/pdf";
        const isImage = selectedFile.type.startsWith("image/");

        if (!isPdf && !isImage) {
            toast.current.show({ severity: "error", summary: "Error", detail: "Only PDF and Image Files are allowed", life: 5000 });
            return;
        }

        const reader = new FileReader();
        reader.readAsArrayBuffer(selectedFile);
        reader.onloadend = () => {
            // limit uploading pdf file with more than 3 pages
            const arrayBuffer = reader.result;
            const uint8Array = new Uint8Array(arrayBuffer);
            let pdfText = '';
            for (let i = 0; i < uint8Array.length; i++) {
                pdfText += String.fromCharCode(uint8Array[i]);
            }
            const countMatch = pdfText.match(/\/Count\s+(\d+)/);
            const pageCount = countMatch ? parseInt(countMatch[1], 10) : 0;
            if (pageCount > 3) {
                toast.current.show({ severity: "error", summary: "Error", detail: "Customer payment card cannot contain more than 3 pages", life: 5000 });
                event.target.value = "";
                return;
            }

            // upload image or pdf with not more than 3 pages
            const base64Reader = new FileReader();
            base64Reader.readAsDataURL(selectedFile);
            base64Reader.onloadend = () => {
                const base64String = base64Reader.result;
                if (base64String !== "") {
                    setLoading(true);
                    const filteredWorksheets = selectedWorksheets.map(({ submissionId, measureId }) => ({ submissionId, measureId }));
                    const requestedData = {
                        submissionMeasureIdsList: filteredWorksheets,
                        base64String: base64String,
                        fileType: isImage ? "image" : "pdf"
                    };
                    const endPoint = SERVICE_LOCATION + UPLOAD_CUSTOMER_PAYMENT_FORM;
                    axios.post(endPoint, requestedData, {
                        headers: {
                            Authorization: `Bearer ${data.data.token}`,
                        },
                    }).then((response) => {
                        setLoading(false);
                        if (response.data.isSuccess) {
                            toast.current.show({ severity: "success", summary: "Success", detail: response.data.data, life: 3000 });
                        }
                        else if (!response.data.isSuccess) {
                            toast.current.show({ severity: "error", summary: "Error", detail: response.data.errorMessage, life: 3000 });
                        }
                    }).catch((error) => {
                        setLoading(false);
                        toast.current.show({ severity: "error", summary: "Error", detail: error, life: 3000 });
                    })
                }
            };
        };
    };
    //End File upload

    return (
        <div className={`app ${loading ? "disabled" : ""}`}>
            {
                loading &&
                <div className="spinner-overlay">
                    <ProgressSpinner style={{ width: "50px", height: "50px" }} strokeWidth="8" fill="var(--surface-ground)" animationDuration=".5s" />
                </div>
            }

            <Toast ref={toast} />
            <div className="worksheets-section">
                <div className="row padb-10">
                    <div className="col-3">
                        <h4>Worksheets</h4>
                    </div>
                    <div className="col-9 buttons-right">
                        <div className="padr-10">
                            <Button className="btn-secondary" onClick={handleFileUpload} disabled={disableUploadPaymentFormButton}>Upload Customer Payment Form</Button>
                            <input ref={fileInputRef} type="file" accept=".pdf, image/*" style={{ display: "none", width: "1024px", height: "768px" }} onChange={handleFileChange} />
                        </div>
                        <div className="padr-10">
                            <Button className="btn-secondary" onClick={handleShowChangeStatusDialog} disabled={disableChangeStatusButton}>Change Status</Button>
                        </div>
                        <div className="padr-10">
                            <Button className="btn-secondary" onClick={handlePDFViewer} disabled={disablePDFViewer}>Pending Worksheet(s) Viewer</Button>
                        </div>
                        <div className="padr-10">
                            <Button className="btn-secondary" onClick={handlePDFDownload} disabled={disableDownloadButton}>Download Worksheet(s) PDF</Button>
                        </div>
                    </div>
                </div>

                <div className="row">
                    <div className="col-12">
                        <DataTable className="font-12" value={worksheets} selection={selectedWorksheets} selectionMode="checkbox"
                            onSelectionChange={handleWorksheetSelection} dataKey="id" paginator rows={10} rowsPerPageOptions={[10, 20, 50]}
                            isDataSelectable={isRowSelectable} rowClassName={rowClassName} removableSort sortMode="multiple"
                            filters={filters} header={header} filterDisplay="row"
                            globalFilterFields={["id", "clientAccount", "clientName", "clientAddress", "clientTerms", "paymentFormRequired",
                                "ContractNumber", "specialNotes", "siteRefNumber", "siteName", "siteAddress", "siteTelNo", "systemId", "plotID", "plotNumber", "plotDescription",
                                "worksheetNo", "worksheetCode", "measureId", "measureStatus", "measureQuantity", "measureCode", "measureDescription", "cavityDepth",
                                "measureType", "planDate", "m2", "depot", "depotCode", "resourceCode", "crew", "submissionId",
                                "submissionType", "submissionStatus", "submittedBy", "submittedDate", "submissionStatusUpdatedBy", "isSubmitted", "isPaperworkUploaded"]}
                            scrollable tableStyle={{ minWidth: "100rem" }} emptyMessage="No worksheets availabe for the selected date range.">
                            <Column selectionMode="multiple" headerStyle={{ width: "3rem" }}></Column>
                            <Column field="id" header="Id" className="table-header" hidden></Column>
                            <Column field="submissionStatus" sortable header="Submission Status" body={statusBodyTemplate} filter filterPlaceholder="Search by status" className="table-header"></Column>
                            <Column field="clientAccount" header="Client Account" className="table-header" hidden></Column>
                            <Column field="clientName" sortable key="clientName" header="Client Name" filter filterPlaceholder="Search by client name" className="table-header" ></Column>
                            <Column field="clientAddress" header="Client Address" className="table-header" hidden></Column>
                            <Column field="clientTerms" header="Client Terms" className="table-header" hidden></Column>
                            <Column field="paymentFormRequired" header="PaymentForm Required" sortable filter filterPlaceholder="Search by payment form required" className="table-header"></Column>
                            <Column field="contractNumber" header="Contract Number" className="table-header" hidden></Column>
                            <Column field="specialNotes" header="Special Notes" className="table-header" hidden></Column>
                            <Column field="siteRefNumber" header="Site Ref Number" className="table-header" hidden></Column>
                            <Column field="siteName" header="Site Name" sortable filter filterPlaceholder="Search by site name" className="table-header"></Column>
                            <Column field="siteAddress" header="Site Address" sortable filter filterPlaceholder="Search by site address" className="table-header"></Column>
                            <Column field="siteTelNo" header="Site Telephone No" filter filterPlaceholder="Search by telephone" className="table-header"></Column>
                            <Column field="systemId" header="SystemId" className="table-header" hidden></Column>
                            <Column field="plotID" header="Plot ID" className="table-header" hidden></Column>
                            <Column field="plotNumber" header="Plot Number" sortable filter filterPlaceholder="Search by plot number" className="table-header"></Column>
                            <Column field="plotDescription" header="Plot Description" filter filterPlaceholder="Search by plot description" className="table-header"></Column>
                            <Column field="worksheetNo" header="Worksheet No" sortable filter filterPlaceholder="Search by worksheet no" className="table-header"></Column>
                            <Column field="worksheetCode" header="Worksheet Code" filter filterPlaceholder="Search by worksheet code" className="table-header" hidden></Column>
                            <Column field="measureId" header="Measure Id" filter filterPlaceholder="Search by measure id" className="table-header" hidden></Column>
                            <Column field="measureStatus" header="Measure Status" sortable filter filterPlaceholder="Search by measure status" className="table-header"></Column>
                            <Column field="measureQuantity" header="Measure Quantity" className="table-header" hidden></Column>
                            <Column field="measureCode" header="Measure Code" sortable filter filterPlaceholder="Search by measure code" className="table-header"></Column>
                            <Column field="measureDescription" header="Measure Description" filter filterPlaceholder="Search by measure description" className="table-header"></Column>
                            <Column field="cavityDepth" header="Cavity Depth" className="table-header" hidden></Column>
                            <Column field="measureType" header="Measure Type" sortable filter filterPlaceholder="Search by measure type" className="table-header"></Column>
                            <Column field="planDate" header="Planed Date" sortable filter filterPlaceholder="Search by plan date" className="table-header"></Column>
                            <Column field="m2" header="M2" className="table-header" hidden></Column>
                            <Column field="depot" header="Depot" sortable filter filterPlaceholder="Search by depot" className="table-header"></Column>
                            <Column field="depotCode" header="Depot Code" className="table-header" hidden></Column>
                            <Column field="resourceCode" header="Resource Code" className="table-header" hidden></Column>
                            <Column field="crew" header="Crew" sortable filter filterPlaceholder="Search by crew" className="table-header"></Column>
                            <Column field="submissionId" header="Submission Id" className="table-header" hidden></Column>
                            <Column field="submissionType" header="Submission Type" className="table-header" hidden></Column>
                            <Column field="submittedBy" header="Submitted By" className="table-header" hidden></Column>
                            <Column field="submittedDate" header="Submitted Date" className="table-header" hidden></Column>
                            <Column field="submissionStatusUpdatedBy" header="Status Updated By" sortable className="table-header" filter filterPlaceholder="Search by status update by"></Column>
                            <Column field="isSubmitted" header="Is Submitted" sortable filter filterPlaceholder="Search by submission" className="table-header"></Column>
                            <Column field="isPaperworkUploaded" header="Is Paperwork Uploaded" sortable filter filterPlaceholder="Search by isPaperworkUploaded" className="table-header"></Column>
                        </DataTable>
                    </div>
                </div>

                <ConfirmDialog visible={changeStatusDialogInPDFViewerVisible} message={changeStatusDialogMessageInPDFViewer} onHide={() => setChangeStatusDialogInPDFViewerVisible(false)}
                    header="Confirmation" icon="pi pi-exclamation-triangle" accept={accept} reject={reject} />

                <Dialog header="Pending Worksheet(s) PDF Viewer" style={{ width: "310vw" }} visible={showPdfViewer} onHide={handleHidePDFViewer}>
                    <div className={`pdf-viewer ${dialogLoading ? "disabled" : ""}`}>
                        {
                            dialogLoading &&
                            <div className="spinner-overlay">
                                <ProgressSpinner style={{ width: "50px", height: "50px" }} strokeWidth="8" fill="var(--surface-ground)" animationDuration=".5s" />
                            </div>
                        }
                        <div className="row">
                            <div className="col-12 col-sm-2 col-md-2 col-lg-2 col-xl-2">
                                <PrimeButton id="back" label="Back" link onClick={handleHidePDFViewer} />
                            </div>
                            <div className="col-12 col-sm-5 col-md-5 col-lg-5 col-xl-5 txt-right">
                                <Message severity="info" text={pdfLoadedMessage} />
                            </div>
                            <div className="col-12 col-sm-5 col-md-5 col-lg-5 col-xl-5 txt-right padb-10">
                                <PrimeButton id="approve" className="marr-10" label="Approve" size="small" outlined onClick={() => handleStatusButtonClick(2)} />
                                <PrimeButton id="siteAttention" className="marr-10" label="Site Attention" size="small" outlined onClick={() => handleStatusButtonClick(4)} />
                                <PrimeButton id="siteRevisit" className="marr-10" label="Site Revisit" size="small" outlined onClick={() => handleStatusButtonClick(3)} />
                            </div>
                        </div>

                        <div>
                            <iframe title="PDF Viewer" width="100%" height="500px" src={pdfUrl || ""} />
                        </div>
                    </div>
                </Dialog>

                <Dialog header="Approve" style={{ width: "50vw" }} visible={showApproveStatusDialogInPDFViewerVisible} onHide={handleStatusDialogVisibilityInPDFViewer} footer={approveStatusfooterContentInPDFViewer}>
                    <div>
                        <div className="row">
                            <div className="col-12 col-sm-4 col-md-4 col-lg-4 col-xl-4 padr-20">
                                <div className="flex flex-column gap-2 fitter-feild">
                                    <label htmlFor="quantity">Quantity</label>
                                    <InputText value={quantity} disabled id="quantity" className="p-inputtext-sm" />
                                </div>
                            </div>
                            <div className="col-12 col-sm-4 col-md-4 col-lg-4 col-xl-4 padr-20">
                                <div className="flex flex-column gap-2 fitter-feild">
                                    <label htmlFor="wage-value">Wage Value(£)</label>
                                    <InputText value={wageValue} disabled id="wage-value" className="p-inputtext-sm" />
                                </div>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-12 col-sm-4 col-md-4 col-lg-4 col-xl-4 padr-20">
                                <div className="flex flex-column gap-2 fitter-feild">
                                    <label htmlFor="fitterNames">Completion Date</label>
                                    <Calendar id="completion-date" name="completion-date" value={completionDate}
                                        onChange={e => setCompletionDate(e.value)} maxDate={completionMaxDate} showIcon dateFormat="dd/mm/yy" />
                                </div>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-12">
                                <DataTable className="font-12" value={selectedFitters} header={fittersHeader} scrollable dataKey="fitterId"
                                    selectionMode="single" selection={selectedRemoveFitter} onSelectionChange={handleRemoveFitterSelection}
                                    tableStyle={{ minWidth: "40rem" }} emptyMessage="No fitters assigned for the selected measures.">
                                    <Column field="fitterId" header="Fitter Id" className="table-header"></Column>
                                    <Column field="fitterName" header="Fitter Name" className="table-header"></Column>
                                    <Column field="workShare" header="% Work" className="table-header" editor={(options) => workShareEditor(options)}></Column>
                                </DataTable>
                            </div>
                        </div>
                    </div>
                </Dialog>

                <Dialog header="Revisit Details" style={{ width: "50vw" }} visible={showSiteRevisitStatusDialogInPDFViewerVisible} onHide={handleStatusDialogVisibilityInPDFViewer} footer={siteRevisitAttentionStatusfooterContentInPDFViewer}>
                    <div>
                        <div className="col-12 padr-20">
                            <div className="col-12 col-sm-6 col-md-6 col-lg-6 col-xl-6 padr-20">
                                <div className="flex flex-column gap-2 cancel-feild">
                                    <label htmlFor="assignedTo">Assigned To</label>
                                    <Dropdown value={assignedTo} onChange={(e) => setAssignedTo(e.value)} options={fitters} optionLabel="fullName"
                                        placeholder="Select Fitter" className="w-full md:w-14rem" />
                                    {assignedToError && <small className="p-error">This field is required</small>}
                                </div>
                            </div>
                        </div>
                        <div className="col-12 padr-20">
                            <div className="col-12 col-sm-6 col-md-6 col-lg-6 col-xl-6 padr-20">
                                <div className="flex flex-column gap-2 cancel-feild">
                                    <label htmlFor="rescheduledDate">Revisit Date</label>
                                    <Calendar value={rescheduledDate} onChange={handleRescheduledDateChange} minDate={minDate} showIcon dateFormat="dd/mm/yy" />
                                </div>
                            </div>
                        </div>
                        <div className="col-12 padr-20">
                            <div className="col-12 col-sm-6 col-md-6 col-lg-6 col-xl-6 padr-20">
                                <div className="flex flex-column gap-2 cancel-feild">
                                    <label htmlFor="rescheduledComments">Reason For Revisit</label>
                                    <InputText value={rescheduledComments} id="rescheduledComments" onChange={(e) => setRescheduledComments(e.target.value)} className="p-inputtext-sm" />
                                    {rescheduledCommentsError && <small className="p-error">This field is required</small>}
                                </div>
                            </div>
                        </div>

                        <div>
                            {!areWagesProcessed &&
                                <div className="row" disabled>
                                    <div className="col-12 col-sm-6 col-md-6 col-lg-6 col-xl-6 padr-20 padb-20">
                                        <div className="flex flex-column gap-2">
                                            <label htmlFor="shouldProcessWages" className="padr-5 txt-bold">Process Wages</label>
                                            <Checkbox value={shouldProcessWages} id="shouldProcessWages" onChange={e => setShouldProcessWages(e.checked)} checked={shouldProcessWages}></Checkbox>
                                        </div>
                                    </div>
                                </div>
                            }

                            {shouldProcessWages &&
                                <div>
                                    <div className="row">
                                        <div className="col-12 col-sm-4 col-md-4 col-lg-4 col-xl-4 padr-20">
                                            <div className="flex flex-column gap-2 fitter-feild">
                                                <label htmlFor="quantity">Quantity</label>
                                                <InputText value={quantity} disabled id="quantity" className="p-inputtext-sm" />
                                            </div>
                                        </div>
                                        <div className="col-12 col-sm-4 col-md-4 col-lg-4 col-xl-4 padr-20">
                                            <div className="flex flex-column gap-2 fitter-feild">
                                                <label htmlFor="wage-value">Wage Value(£)</label>
                                                <InputText value={wageValue} disabled id="wage-value" className="p-inputtext-sm" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-12 col-sm-4 col-md-4 col-lg-4 col-xl-4 padr-20">
                                            <div className="flex flex-column gap-2 fitter-feild">
                                                <label htmlFor="fitterNames">Completion Date</label>
                                                <Calendar id="completion-date" name="completion-date" value={completionDate}
                                                    onChange={e => setCompletionDate(e.value)} maxDate={completionMaxDate} showIcon dateFormat="dd/mm/yy" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-12">
                                            <DataTable className="font-12" value={selectedFitters} header={fittersHeader} scrollable dataKey="fitterId"
                                                selectionMode="single" selection={selectedRemoveFitter} onSelectionChange={handleRemoveFitterSelection}
                                                tableStyle={{ minWidth: "40rem" }} emptyMessage="No fitters assigned for the selected measures.">
                                                <Column field="fitterId" header="Fitter Id" className="table-header"></Column>
                                                <Column field="fitterName" header="Fitter Name" className="table-header"></Column>
                                                <Column field="workShare" header="% Work" className="table-header" editor={(options) => workShareEditor(options)}></Column>
                                            </DataTable>
                                        </div>
                                    </div>
                                </div>
                            }
                        </div>
                    </div>
                </Dialog>

                <Dialog header="Site Attention" style={{ width: "50vw" }} visible={showSiteAttentionStatusDialogInPDFViewerVisible} onHide={handleStatusDialogVisibilityInPDFViewer} footer={siteRevisitAttentionStatusfooterContentInPDFViewer}>
                    <div>
                        <div className="row" disabled>
                            <div className="col-12 col-sm-6 col-md-6 col-lg-6 col-xl-6 padr-20">
                                <div className="flex flex-column gap-2 cancel-feild">
                                    <label htmlFor="emailTo">Email To</label>
                                    <InputTextarea disabled rows={4} cols={30} value={emailTo} onChange={(e) => setEmailTo(e.value)} autoResize tooltip="Select recipients from below site contacts table" tooltipOptions={{ position: "top" }} />
                                    {emailToError && <small className="p-error">This field is required</small>}
                                </div>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-12">
                                <DataTable className="font-12" value={siteContactsList} selectionMode="checkbox" selection={selectedSiteContacts}
                                    onSelectionChange={handleSiteContactSelection} header={siteContactsHeader} scrollable dataKey="id"
                                    tableStyle={{ minWidth: "40rem" }} emptyMessage="No site contacts availabe for the selected worksheet.">
                                    <Column selectionMode="multiple" headerStyle={{ width: "3rem" }}></Column>
                                    <Column field="id" header="Id" className="table-header" hidden></Column>
                                    <Column field="systemId" header="SystemId" className="table-header" hidden></Column>
                                    <Column field="title" header="Title" className="table-header" hidden></Column>
                                    <Column field="firstName" header="FirstName" className="table-header"></Column>
                                    <Column field="lastName" header="LastName" className="table-header"></Column>
                                    <Column field="email" header="Email" className="table-header"></Column>
                                    <Column field="position" header="Position" className="table-header"></Column>
                                    <Column field="telephone" header="Telephone" className="table-header" hidden></Column>
                                    <Column field="mobile" header="Mobile" className="table-header" hidden></Column>
                                    <Column field="comments" header="Comments" className="table-header" hidden></Column>
                                    <Column field="isPrimaryContact" header="IsPrimaryContact" className="table-header" hidden></Column>
                                    <Column body={deleteBodyTemplate} header="Delete" headerStyle={{ width: "3rem" }} exportable={false}></Column>
                                </DataTable>
                            </div>
                        </div>
                        <div className="col-12 padr-20">
                            <div className="col-12 col-sm-8 col-md-8 col-lg-8 col-xl-8 padr-20 padt-23">
                                <div className="flex flex-column gap-2 cancel-feild">
                                    <label htmlFor="emailBody">Email</label>
                                    <Editor value={emailBody} onTextChange={(e) => setEmailBody(e.htmlValue)} style={{ height: "200px" }} />
                                    {emailBodyError && <small className="p-error">This field is required</small>}
                                </div>
                            </div>
                        </div>

                        <div>
                            {!areWagesProcessed &&
                                <div className="row" disabled>
                                    <div className="col-12 col-sm-6 col-md-6 col-lg-6 col-xl-6 padr-20 padb-20">
                                        <div className="flex flex-column gap-2">
                                            <label htmlFor="shouldProcessWages" className="padr-5 txt-bold">Process Wages</label>
                                            <Checkbox value={shouldProcessWages} id="shouldProcessWages" onChange={e => setShouldProcessWages(e.checked)} checked={shouldProcessWages}></Checkbox>
                                        </div>
                                    </div>
                                </div>
                            }

                            {shouldProcessWages &&
                                <div>
                                    <div className="row">
                                        <div className="col-12 col-sm-4 col-md-4 col-lg-4 col-xl-4 padr-20">
                                            <div className="flex flex-column gap-2 fitter-feild">
                                                <label htmlFor="quantity">Quantity</label>
                                                <InputText value={quantity} disabled id="quantity" className="p-inputtext-sm" />
                                            </div>
                                        </div>
                                        <div className="col-12 col-sm-4 col-md-4 col-lg-4 col-xl-4 padr-20">
                                            <div className="flex flex-column gap-2 fitter-feild">
                                                <label htmlFor="wage-value">Wage Value(£)</label>
                                                <InputText value={wageValue} disabled id="wage-value" className="p-inputtext-sm" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-12 col-sm-4 col-md-4 col-lg-4 col-xl-4 padr-20">
                                            <div className="flex flex-column gap-2 fitter-feild">
                                                <label htmlFor="fitterNames">Completion Date</label>
                                                <Calendar id="completion-date" name="completion-date" value={completionDate}
                                                    onChange={e => setCompletionDate(e.value)} maxDate={completionMaxDate} showIcon dateFormat="dd/mm/yy" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-12">
                                            <DataTable className="font-12" value={selectedFitters} header={fittersHeader} scrollable dataKey="fitterId"
                                                selectionMode="single" selection={selectedRemoveFitter} onSelectionChange={handleRemoveFitterSelection}
                                                tableStyle={{ minWidth: "40rem" }} emptyMessage="No fitters assigned for the selected measures.">
                                                <Column field="fitterId" header="Fitter Id" className="table-header"></Column>
                                                <Column field="fitterName" header="Fitter Name" className="table-header"></Column>
                                                <Column field="workShare" header="% Work" className="table-header" editor={(options) => workShareEditor(options)}></Column>
                                            </DataTable>
                                        </div>
                                    </div>
                                </div>
                            }
                        </div>
                    </div>
                </Dialog>

                <Dialog header="Change Status" style={{ width: "50vw" }} visible={showChangeStatusDialog} onHide={handleHideChangeStatusDialouge} footer={changeStatusfooterContent}>
                    <div>
                        <div className="col-12 padr-20">
                            <div className="col-12 col-sm-6 col-md-6 col-lg-6 col-xl-6 padr-20">
                                <div className="flex flex-column gap-2 cancel-feild">
                                    <label htmlFor="currentStatus">Current Status</label>
                                    <InputText disabled value={currentStatus} id="currentStatus" onChange={(e) => setCurrentStatus(e.target.value)} className="p-inputtext-sm" />
                                </div>
                            </div>
                        </div>

                        <div className="col-12 col-sm-6 col-md-6 col-lg-6 col-xl-6 padr-20">
                            <div className="flex flex-column gap-2 cancel-feild">
                                <label htmlFor="changedStatus">Change Status To</label>
                                <Dropdown value={changedStatus} onChange={handleChangedStatusDropdown} options={submissionStatusList} optionLabel="status"
                                    placeholder="Select Status" className="w-full md:w-14rem" />
                            </div>
                        </div>

                        {changedStatus.status === "Approved" && !areWagesProcessed &&
                            <div>
                                <div className="row">
                                    <div className="col-12 col-sm-4 col-md-4 col-lg-4 col-xl-4 padr-20">
                                        <div className="flex flex-column gap-2 fitter-feild">
                                            <label htmlFor="quantity">Quantity</label>
                                            <InputText value={quantity} disabled id="quantity" className="p-inputtext-sm" />
                                        </div>
                                    </div>
                                    <div className="col-12 col-sm-4 col-md-4 col-lg-4 col-xl-4 padr-20">
                                        <div className="flex flex-column gap-2 fitter-feild">
                                            <label htmlFor="wage-value">Wage Value(£)</label>
                                            <InputText value={wageValue} disabled id="wage-value" className="p-inputtext-sm" />
                                        </div>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-12 col-sm-4 col-md-4 col-lg-4 col-xl-4 padr-20">
                                        <div className="flex flex-column gap-2 fitter-feild">
                                            <label htmlFor="fitterNames">Completion Date</label>
                                            <Calendar id="completion-date" name="completion-date" value={completionDate}
                                                onChange={e => setCompletionDate(e.value)} maxDate={completionMaxDate} showIcon dateFormat="dd/mm/yy" />
                                        </div>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-12">
                                        <DataTable className="font-12" value={selectedFitters} header={fittersHeader} scrollable dataKey="fitterId"
                                            selectionMode="single" selection={selectedRemoveFitter} onSelectionChange={handleRemoveFitterSelection}
                                            tableStyle={{ minWidth: "40rem" }} emptyMessage="No fitters assigned for the selected measures.">
                                            <Column field="fitterId" header="Fitter Id" className="table-header"></Column>
                                            <Column field="fitterName" header="Fitter Name" className="table-header"></Column>
                                            <Column field="workShare" header="% Work" className="table-header" editor={(options) => workShareEditor(options)}></Column>
                                        </DataTable>
                                    </div>
                                </div>
                            </div>
                        }

                        {changedStatus.status === "Site Revisit" &&
                            <div>
                                <div className="col-12 padr-20">
                                    <div className="col-12 col-sm-6 col-md-6 col-lg-6 col-xl-6 padr-20">
                                        <div className="flex flex-column gap-2 cancel-feild">
                                            <label htmlFor="assignedTo">Assigned To</label>
                                            <Dropdown value={assignedTo} onChange={(e) => setAssignedTo(e.value)} options={fitters} optionLabel="fullName"
                                                placeholder="Select Fitter" className="w-full md:w-14rem" />
                                            {assignedToError && <small className="p-error">This field is required</small>}
                                        </div>
                                    </div>
                                </div>
                                <div className="col-12 padr-20">
                                    <div className="col-12 col-sm-6 col-md-6 col-lg-6 col-xl-6 padr-20">
                                        <div className="flex flex-column gap-2 cancel-feild">
                                            <label htmlFor="rescheduledDate">Revisit Date</label>
                                            <Calendar value={rescheduledDate} onChange={handleRescheduledDateChange} minDate={minDate} showIcon dateFormat="dd/mm/yy" />
                                        </div>
                                    </div>
                                </div>
                                <div className="col-12 padr-20">
                                    <div className="col-12 col-sm-6 col-md-6 col-lg-6 col-xl-6 padr-20">
                                        <div className="flex flex-column gap-2 cancel-feild">
                                            <label htmlFor="rescheduledComments">Reason For Revisit</label>
                                            <InputText value={rescheduledComments} id="rescheduledComments" onChange={(e) => setRescheduledComments(e.target.value)} className="p-inputtext-sm" />
                                            {rescheduledCommentsError && <small className="p-error">This field is required</small>}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        }

                        {changedStatus.status === "Site Attention" &&
                            <div>
                                <div className="row" disabled>
                                    <div className="col-12 col-sm-6 col-md-6 col-lg-6 col-xl-6 padr-20">
                                        <div className="flex flex-column gap-2 cancel-feild">
                                            <label htmlFor="emailTo">Email To</label>
                                            <InputTextarea disabled rows={3} cols={30} value={emailTo} onChange={(e) => setEmailTo(e.value)} autoResize tooltip="Select recipients from below site contacts table" tooltipOptions={{ position: "top" }} />
                                            {emailToError && <small className="p-error">This field is required</small>}
                                        </div>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-12">
                                        <DataTable className="font-12" value={siteContactsList} selectionMode="checkbox" selection={selectedSiteContacts}
                                            onSelectionChange={handleSiteContactSelection} header={siteContactsHeader} scrollable dataKey="id"
                                            tableStyle={{ minWidth: "40rem" }} emptyMessage="No site contacts availabe for the selected worksheet.">
                                            <Column selectionMode="multiple" headerStyle={{ width: "3rem" }}></Column>
                                            <Column field="id" header="Id" className="table-header" hidden></Column>
                                            <Column field="systemId" header="SystemId" className="table-header" hidden></Column>
                                            <Column field="title" header="Title" className="table-header" hidden></Column>
                                            <Column field="firstName" header="FirstName" className="table-header"></Column>
                                            <Column field="lastName" header="LastName" className="table-header"></Column>
                                            <Column field="email" header="Email" className="table-header"></Column>
                                            <Column field="position" header="Position" className="table-header"></Column>
                                            <Column field="telephone" header="Telephone" className="table-header" hidden></Column>
                                            <Column field="mobile" header="Mobile" className="table-header" hidden></Column>
                                            <Column field="comments" header="Comments" className="table-header" hidden></Column>
                                            <Column field="isPrimaryContact" header="IsPrimaryContact" className="table-header" hidden></Column>
                                            <Column body={deleteBodyTemplate} header="Delete" headerStyle={{ width: "3rem" }} exportable={false}></Column>
                                        </DataTable>
                                    </div>
                                </div>
                                <div className="col-12 padr-20">
                                    <div className="col-12 col-sm-8 col-md-8 col-lg-8 col-xl-8 padr-20 padt-23">
                                        <div className="flex flex-column gap-2 cancel-feild">
                                            <label htmlFor="emailBody">Email</label>
                                            {/* <ReactQuill theme="snow" value={emailBody} onChange={(e) => setEmailBody(e.value)} style={{height: "200px"}} /> */}
                                            <Editor value={emailBody} onTextChange={(e) => setEmailBody(e.htmlValue)} style={{ height: "200px" }} />
                                            {emailBodyError && <small className="p-error">This field is required</small>}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        }

                        {(changedStatus.status === "Site Revisit" || changedStatus.status === "Site Attention") &&
                            <div>
                                {!areWagesProcessed &&
                                    <div className="row" disabled>
                                        <div className="col-12 col-sm-6 col-md-6 col-lg-6 col-xl-6 padr-20 padb-20">
                                            <div className="flex flex-column gap-2">
                                                <label htmlFor="shouldProcessWages" className="padr-5 txt-bold">Process Wages</label>
                                                <Checkbox value={shouldProcessWages} id="shouldProcessWages" onChange={e => setShouldProcessWages(e.checked)} checked={shouldProcessWages}></Checkbox>
                                            </div>
                                        </div>
                                    </div>
                                }

                                {shouldProcessWages &&
                                    <div>
                                        <div className="row">
                                            <div className="col-12 col-sm-4 col-md-4 col-lg-4 col-xl-4 padr-20">
                                                <div className="flex flex-column gap-2 fitter-feild">
                                                    <label htmlFor="quantity">Quantity</label>
                                                    <InputText value={quantity} disabled id="quantity" className="p-inputtext-sm" />
                                                </div>
                                            </div>
                                            <div className="col-12 col-sm-4 col-md-4 col-lg-4 col-xl-4 padr-20">
                                                <div className="flex flex-column gap-2 fitter-feild">
                                                    <label htmlFor="wage-value">Wage Value(£)</label>
                                                    <InputText value={wageValue} disabled id="wage-value" className="p-inputtext-sm" />
                                                </div>
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col-12 col-sm-4 col-md-4 col-lg-4 col-xl-4 padr-20">
                                                <div className="flex flex-column gap-2 fitter-feild">
                                                    <label htmlFor="fitterNames">Completion Date</label>
                                                    <Calendar id="completion-date" name="completion-date" value={completionDate}
                                                        onChange={e => setCompletionDate(e.value)} maxDate={completionMaxDate} showIcon dateFormat="dd/mm/yy" />
                                                </div>
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col-12">
                                                <DataTable className="font-12" value={selectedFitters} header={fittersHeader} scrollable dataKey="fitterId"
                                                    selectionMode="single" selection={selectedRemoveFitter} onSelectionChange={handleRemoveFitterSelection}
                                                    tableStyle={{ minWidth: "40rem" }} emptyMessage="No fitters assigned for the selected measures.">
                                                    <Column field="fitterId" header="Fitter Id" className="table-header"></Column>
                                                    <Column field="fitterName" header="Fitter Name" className="table-header"></Column>
                                                    <Column field="workShare" header="% Work" className="table-header" editor={(options) => workShareEditor(options)}></Column>
                                                </DataTable>
                                            </div>
                                        </div>
                                    </div>
                                }
                            </div>
                        }
                    </div>
                </Dialog>

                <Dialog header="Add Site Contact" style={{ width: "30vw" }} visible={showAddSiteContactDialog} onHide={onHideAddSiteContactsDialog} footer={addSiteContactfooterContent}>
                    <div className="row">
                        <div className="col-12 col-sm-6 col-md-6 col-lg-6 col-xl-6 padr-20">
                            <div className="flex flex-column gap-2 input-feild">
                                <label htmlFor="depot">Title</label>
                                <Dropdown value={siteContactTitle} onChange={(e) => setSiteContactTitle(e.value)} options={titles} optionLabel="title"
                                    placeholder="Select Title" className="w-full md:w-14rem" />
                            </div>
                        </div>
                        <div className="col-12 col-sm-6 col-md-6 col-lg-6 col-xl-6 padr-20">
                            <div className="flex flex-column gap-2 input-feild">
                                <label htmlFor="siteContactFirstName">First Name</label>
                                <InputText value={siteContactFirstName} id="siteContactFirstName" onChange={(e) => setSiteContactFirstName(e.target.value)} className="p-inputtext-sm" />
                            </div>
                        </div>

                        <div className="col-12 col-sm-6 col-md-6 col-lg-6 col-xl-6 padr-20">
                            <div className="flex flex-column gap-2 input-feild">
                                <label htmlFor="siteContactLastName">Last Name</label>
                                <InputText value={siteContactLastName} id="siteContactLastName" onChange={(e) => setSiteContactLastName(e.target.value)} className="p-inputtext-sm" />
                            </div>
                        </div>

                        <div className="col-12 col-sm-6 col-md-6 col-lg-6 col-xl-6 padr-20">
                            <div className="flex flex-column gap-2 input-feild">
                                <label htmlFor="siteContactPosition">Position</label>
                                <InputText value={siteContactPosition} id="siteContactPosition" onChange={(e) => setSiteContactPosition(e.target.value)} className="p-inputtext-sm" />
                            </div>
                        </div>

                        <div className="col-12 col-sm-6 col-md-6 col-lg-6 col-xl-6 padr-20">
                            <div className="flex flex-column gap-2 input-feild">
                                <label htmlFor="siteContactTelephone">Phone</label>
                                <InputText value={siteContactTelephone} id="siteContactTelephone" onChange={(e) => setSiteContactTelephone(e.target.value)} className="p-inputtext-sm" />
                            </div>
                        </div>

                        <div className="col-12 col-sm-6 col-md-6 col-lg-6 col-xl-6 padr-20">
                            <div className="flex flex-column gap-2 input-feild">
                                <label htmlFor="siteContactMobile">Mobile</label>
                                <InputText value={siteContactMobile} id="siteContactMobile" onChange={(e) => setSiteContactMobile(e.target.value)} className="p-inputtext-sm" />
                            </div>
                        </div>

                        <div className="col-12 col-sm-6 col-md-6 col-lg-6 col-xl-6 padr-20">
                            <div className="flex flex-column gap-2 input-feild">
                                <label htmlFor="siteContactEmail">Email</label>
                                <InputText value={siteContactEmail} id="siteContactEmail" onChange={(e) => setSiteContactEmail(e.target.value)} className="p-inputtext-sm" />
                            </div>
                        </div>

                        <div className="col-12 col-sm-6 col-md-6 col-lg-6 col-xl-6 padr-20">
                            <div className="flex flex-column gap-2 input-feild">
                                <label htmlFor="siteContactComments">Comments</label>
                                <InputText value={siteContactComments} id="siteContactComments" onChange={(e) => setSiteContactComments(e.target.value)} className="p-inputtext-sm" />
                            </div>
                        </div>

                        <div className="col-12 padr-20 padb-20">
                            <div className="col-12 col-sm-6 col-md-6 col-lg-6 col-xl-6">
                                <div className="flex flex-column gap-2">
                                    <label htmlFor="isPrimaryContact" className="padr-5">IsPrimaryContact</label>
                                    <Checkbox value={isPrimaryContact} id="isPrimaryContact" onChange={e => setIsPrimaryContact(e.checked)} checked={isPrimaryContact}></Checkbox>
                                </div>
                            </div>
                        </div>
                    </div>
                </Dialog>

                <Dialog visible={deleteSiteContactDialog} style={{ width: "20vw" }} header="Confirm" modal footer={deleteProductDialogFooter} onHide={() => setDeleteSiteContactDialog(false)}>
                    <div className="confirmation-content">
                        {deleteSiteContact && (
                            <span>
                                Are you sure you want to delete the contact for <b>{deleteSiteContact.firstName} {deleteSiteContact.lastName}</b>?
                            </span>
                        )}
                    </div>
                </Dialog>

                <Dialog header="Select Fitter" visible={showAddFitter} style={{ width: "30vw" }} contentStyle={{ height: "25vw" }}
                    onHide={() => setShowAddFitter(false)} footer={addFitterFooterContent}>
                    <div>
                        <div className="row col-12">
                            <DataTable className="font-12" value={fitters} scrollable dataKey="fitterId"
                                filters={addFitterFilters} header={addFitterHeader} globalFilterFields={["fitterId", "fullName"]}
                                selectionMode="single" selection={selectedAddFitter} onSelectionChange={handleFitterSelectionInAddFitterModal}
                                tableStyle={{ minWidth: "20rem" }} emptyMessage="No fitters available.">
                                <Column field="fitterId" header="Fitter Id" className="table-header"></Column>
                                <Column field="fullName" header="Fitter Name" className="table-header"></Column>
                            </DataTable>
                        </div>
                    </div>
                </Dialog>
            </div>
        </div>
    )
}

export default Worksheets;